/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { ContactTranscriptSummary } from './ContactTranscriptSummary.js';
import {
    ContactTranscriptSummaryFromJSON,
    ContactTranscriptSummaryFromJSONTyped,
    ContactTranscriptSummaryToJSON,
} from './ContactTranscriptSummary.js';

/**
 * 
 * @export
 * @interface GetContactTranscriptSummaryResponse
 */
export interface GetContactTranscriptSummaryResponse {
    /**
     * 
     * @type {ContactTranscriptSummary}
     * @memberof GetContactTranscriptSummaryResponse
     */
    data?: ContactTranscriptSummary;
    /**
     * 
     * @type {number}
     * @memberof GetContactTranscriptSummaryResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof GetContactTranscriptSummaryResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof GetContactTranscriptSummaryResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof GetContactTranscriptSummaryResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the GetContactTranscriptSummaryResponse interface.
 */
export function instanceOfGetContactTranscriptSummaryResponse(value: object): boolean {
    return true;
}

export function GetContactTranscriptSummaryResponseFromJSON(json: any): GetContactTranscriptSummaryResponse {
    return GetContactTranscriptSummaryResponseFromJSONTyped(json, false);
}

export function GetContactTranscriptSummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetContactTranscriptSummaryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ContactTranscriptSummaryFromJSON(json['data']),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function GetContactTranscriptSummaryResponseToJSON(value?: GetContactTranscriptSummaryResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': ContactTranscriptSummaryToJSON(value['data']),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

